var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSorting = function SvgSorting(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-24": 20,
    viewBox: "0 0 14 12.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.203.16a.6.6 0 0 0-.814 0L.193 3.11a.6.6 0 1 0 .814.881l2.189-2.02v9.447a.6.6 0 1 0 1.2 0V1.97l2.189 2.021a.6.6 0 0 0 .814-.882zM9.78 11.858a.6.6 0 0 0 .814 0l3.196-2.95a.6.6 0 1 0-.814-.882l-2.19 2.02V.6a.6.6 0 0 0-1.2 0v9.447L7.4 8.027a.6.6 0 1 0-.814.881z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSorting);
export default ForwardRef;